export default [
  // Greendale Community College
  {
    id: '1',
    totalNewTeachersNotReviewed: 1,
    totalNewTeachersWithCreateNewRecord: 1,
    totalNewTeachersWithDoNotSync: 0,
    totalExistingTeachersWithErrorCode: 1,
  },
  // City College
  {
    id: '2',
    totalNewTeachersNotReviewed: 26,
    totalNewTeachersWithCreateNewRecord: 23,
    totalNewTeachersWithDoNotSync: 3,
    totalNewStudentsNotReviewed: 2,
    totalNewStudentsWithCreateNewRecord: 1,
    totalNewStudentsWithDoNotSync: 1,
    totalExistingTeachersWithSyncToRecord: 3,
    totalExistingStudentsWithSyncToRecord: 1,
    totalClassesNotReviewed: 2,
    totalClassesWithCreateNewRecord: 2,
    totalClassesWithDoNotSync: 1,
    totalGroupsNotReviewed: 2,
    totalGroupsWithCreateNewRecord: 1,
    totalGroupsWithDoNotSync: 2,
  },
  // Athabasca High School
  {
    id: '3',
    totalNewTeachersNotReviewed: 10,
    totalUsersSynced: 0,
    totalUsersNotSynced: 0,
  },
  // Brazeau Elementary School
  {
    id: '4',
    totalNewStudentsNotReviewed: 0,
    totalNewTeachersNotReviewed: 0,
    totalNewStudentsWithCreateNewRecord: 0,
    totalNewTeachersWithCreateNewRecord: 0,
  },
  // Doyle Elementary School
  {
    id: '5',
    totalNewTeachersNotReviewed: 0,
    totalExistingTeachersWithDoNotSync: 0,
    totalExistingTeachersWithSyncToRecord: 1,
    totalExistingTeachersNotReviewed: 1,
    lastSyncDate: 1704092400000, // January 1, 2024
    totalTeachersSynced: 15,
    totalStudentsSynced: 5,
    totalStudentsWithSystemErrorMessage: 1,
    totalTeachersWithSystemErrorMessage: 2,
    totalClassesSynced: 8,
    totalClassesWithSystemErrorMessage: 1,
    totalGroupsWithSystemErrorMessage: 1,
  },
  // Alaska Elementary School
  {
    id: '6',
    totalNewStudentsNotReviewed: 5,
  },
  // Hogwarts School
  {
    id: '7',
    totalNewTeachersNotReviewed: 1,
    totalNewTeachersWithCreateNewRecord: 1,
    totalClassesWithCreateNewRecord: 1,
    totalClassesWithDoNotSync: 0,
  },
];
